import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService, ContractStatus, LoginUserToken } from '../../authentication.service';
import { UserService } from '../../user.service';
import { BaseUser } from '../../models/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { ErrorsComponent } from '@styleguide/error/errors/errors.component';
import { LoadingDirective } from '@styleguide/loading/loading.directive';

enum States {
  'idle',
  'processing',
  'error',
}

@Component({
  selector: 'kgr-select-login-user',
  templateUrl: './select-login-user.component.html',
  styleUrls: ['./select-login-user.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorsComponent, LoadingDirective, AsyncPipe],
})
export class SelectLoginUserComponent implements OnInit {
  @Output() loginResult = new EventEmitter<boolean>();

  state$ = new BehaviorSubject<States>(States.idle);
  readonly States = States;
  readonly LoginStatus = ContractStatus;

  loginUserTokens$: Observable<LoginUserToken[]>;

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService<BaseUser>,
  ) {}

  ngOnInit(): void {
    this.loginUserTokens$ = this.authenticationService.readLoginUserTokens().pipe(
      tap((loginUserTokens) => {
        if (loginUserTokens.length === 0) {
          this.authenticationService.logout().subscribe(() => console.log('no user login tokens - logged out'));
        }
      }),
    );
  }

  loginByLoginUserToken(loginUserToken: LoginUserToken) {
    this.state$.next(States.processing);
    if (loginUserToken.token && this.authenticationService.loginByToken(loginUserToken.token)) {
      this.loginResult.emit(true);
    } else {
      this.state$.next(States.error);
    }
  }

  onLogoutClick() {
    this.authenticationService.logout().subscribe(() => this.loginResult.emit(false));
  }
}
